import { DslOperator } from './types';

export const DSL_OPERATORS: DslOperator[] = ['contains', 'equals', 'startsWith', 'endsWith'];

export const DSL_OPERATOR_DESCRIPTIONS: Record<DslOperator, string> = {
    contains: 'substring',
    equals: 'exact',
    startsWith: 'prefix',
    endsWith: 'suffix'
};

export const DSL_OPERATOR_WORDS = new Set<string>(DSL_OPERATORS);

export const DSL_MAX_LENGTH = 4096;

export const DSL_MAX_PAREN_DEPTH = 20;
